/* eslint-disable complexity */
/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable no-nested-ternary */
import React from 'react';
import classNames from 'classnames';
import TestUserInfo from './TestUserInfo';
import Subtest from './Subtest';
import SubtestReport from './SubtestReport';
import SubtestAnswers from './SubtestAnswers';
import strings from 'utils/strings';
import getQuestionChoices from '../Utils/getQuestionChoices';
import moment from 'moment';
import {connect} from 'react-redux';
import '../../TestView/styles.scss';

import getSingleTestResult from 'api/getSingleTestResult';
import updateLogEvent from 'api/updateLogEvent';

import {withRouter} from 'react-router-dom';

import HorizontalBarChart from 'components/HorizontalBarChart';

import childWordchainAnswers from './child-wordchain-answers.json';
import childWordchainAnswersNn from './child-wordchain-answers-nn.json';
import test5Questions from './test5.json';
import test6Questions from './test6.json';
import test5youthQuestions from './test5youth.json';
import test5youthQuestionsNn from './test5youthNn.json';
import test6youthQuestions from './test6youth.json';
import test6youthQuestionsNn from './test6youthNn.json';

import test5childQuestions from './test5child.json';
import test5childQuestionsNn from './test5childNn.json';
import test6childQuestions from './test6child.json';
import test6childQuestionsNn from './test6childNn.json';
import test6childUpperQuestions from './test6childUpper.json';
import test6childUpperQuestionsNn from './test6childUpperNn.json';
import {timeSinceWCaltered} from '../../../constants';
import HandBook from './HandBook';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint} from '@fortawesome/free-solid-svg-icons';
import Assessment from './assessment';
import AddNotesModal from '../../../components/AddNotesModal';

const NOT_AVAILABLE = strings.notavailable || 'Inte tillgänglig';

const get = (object, path, fallback) => {
	if (!object || !path) {
		return fallback;
	}

	const value = path.split('.').reduce((current, key) => {
		if (current && Object.prototype.hasOwnProperty.call(current, key)) {
			return current[key];
		}

		return undefined;
	}, object);

	return value === undefined || value === null ? fallback : value;
};

const hasValue = (value) => {
	return value !== undefined && value !== null && value !== '';
};

const asArray = (value) => {
	return Array.isArray(value) ? value : [];
};

const asString = (value) => {
	return hasValue(value) ? String(value) : '';
};

const getSafeQuestionChoices = (question) => {
	if (!question || !question.choices) {
		return {};
	}

	return getQuestionChoices(question);
};

const getCompleteName = (testUser) => {
	const firstName = get(testUser, 'firstName', '');
	const lastName = get(testUser, 'lastName', '');

	if (!firstName) {
		return strings.hiddenname;
	}

	return `${firstName} ${lastName || ''}`.trim();
};

const formatBirthDate = (birthDate) => {
	if (!birthDate) {
		return '';
	}

	const parsedDate = moment(birthDate);

	if (!parsedDate.isValid()) {
		return '';
	}

	return ` Född: ${parsedDate.format('DD.MM.YYYY')}`;
};
class SingleTest extends React.Component {
	constructor() {
		super();
		this.state = {
			showTestUserInfo: false,
			testResult: null,
			testType: null,
			testId: null,
			testKey: null,
			showResultsTab: false,
			showReportTab: true,
			showInformationTab: false,
			showHandBookTab: false,
			showResultsActive: 'tablink1',
			showReportActive: 'tablink2-active',
			showInformationActive: 'tablink3',
			showHandBookActive: 'tablink4',
			showAddNotesModal: false,
			reportNotes: '',

			birthDate: null,
			buttonTabs: [
				{
					id: 2,
					value: 'report',
					buttonClass: 'tablink2-active',
					text: 'Rapport',
				},
				{
					id: 'defaultOpen',
					value: 'result',
					buttonClass: 'tablink1',
					text: 'Resultat',
				},
				{
					id: 3,
					value: 'info',
					buttonClass: 'tablink3',
					text: strings.userinformation,
				},
				{
					id: 4,
					value: 'book',
					buttonClass: 'tablink4',
					text: 'Handbok',
				},
			],
		};
	}

	componentDidMount() {
		const id = get(this.props, 'match.params.id');
		window.scrollTo(0, 0);
		getSingleTestResult(id).then((testResult) => {
			const safeTestResult = testResult || {};
			const testType = safeTestResult.type;
			const testUser = safeTestResult.testUser || safeTestResult || {};
			const normalizedTestResult = Object.assign({}, safeTestResult, {
				testUser,
				subtests: asArray(safeTestResult.subtests),
			});

			const birthDate = formatBirthDate(
				get(testUser, 'birthDate') || get(testUser, 'birthdate')
			);

			normalizedTestResult.subtests.map((subtest) => {
				let questions = false;
				switch (testType) {
					case 'adult-screening':
						if (subtest.id === 5) {
							questions = test5Questions;
						} else if (subtest.id === 6) {
							questions = test6Questions;
						}
						break;

					case 'youth-screening':
						if (subtest.id === 5 && subtest.language === 'se') {
							questions = test5youthQuestions;
						} else if (
							subtest.id === 6 &&
							subtest.language === 'se'
						) {
							questions = test6youthQuestions;
						}
						break;
					case 'child-screening':
						const processedTestResult =
							this.reOrderChildScreening(normalizedTestResult);

						const processedTestUser =
							processedTestResult.testUser || {};
						const childGrade = get(
							processedTestUser,
							'education.youthGrade'
						);
						const childGradeKey = hasValue(childGrade)
							? childGrade.toString()
							: '';

						if (subtest.id === 5 && subtest.language === 'se') {
							questions = childGradeKey
								? test5childQuestions[childGradeKey]
								: false;
						} else if (
							subtest.id === 6 &&
							subtest.language === 'se'
						) {
							if (Number(childGrade) < 4) {
								questions = test6childQuestions;
							} else {
								questions = test6childUpperQuestions;
							}
						}
						break;
				}

				if (subtest.id === 4) {
					subtest.formattedAnswers = this.formatTypingSpeedAnswers(
						subtest.answers
					);
				} else if (subtest.id === 1 && testType === 'child-screening') {
					const childGrade = get(testUser, 'education.youthGrade');

					subtest.formattedAnswers =
						this.getAnswersWithCorrectAnswerforWD(
							subtest.answers,
							subtest.answersCorrect,
							questions,
							childGrade
						);
				} else if (subtest.id === 2 && testType === 'child-screening') {
					subtest.formattedAnswers =
						this.getAnswersWithCorrectAnswerforWC(
							subtest.createdAt,
							subtest.answers,
							subtest.answersCorrect,
							childWordchainAnswers,
							childWordchainAnswersNn,
							questions,
							subtest.language
						);
				} else {
					subtest.formattedAnswers = this.getAnswersWithCorrectAnswer(
						subtest.answers,
						subtest.answersCorrect,
						questions
					);
				}

				return subtest;
			});
			this.setState({
				testResult: normalizedTestResult,
				testId: normalizedTestResult.id,
				testKey: normalizedTestResult.key,
				testType: testType,
				testUser,
				birthDate,
			});
		});
	}
	reOrderChildScreening(testResult) {
		const safeTestResult = testResult || {};
		const safeSubtests = asArray(safeTestResult.subtests);
		let allSubtests = [];

		for (let i = 0; i < safeSubtests.length; i++) {
			switch (safeSubtests[i].id) {
				case 3:
					allSubtests[0] = safeSubtests[i];
					break;
				case 2:
					allSubtests[1] = safeSubtests[i];
					break;
				case 4:
					allSubtests[2] = safeSubtests[i];
					break;
				case 6:
					allSubtests[3] = safeSubtests[i];
					break;
				case 5:
					allSubtests[4] = safeSubtests[i];
					break;
				case 1:
					allSubtests[5] = safeSubtests[i];
					break;
			}
		}
		if (allSubtests.length) {
			allSubtests = allSubtests.filter(function (element) {
				return element !== undefined;
			});

			safeTestResult.subtests = allSubtests;
		}
		return safeTestResult;
	}

	updatePrintLog(action) {
		updateLogEvent('print', this.state.testId, '', action);
	}

	formatTypingSpeedAnswers(answers) {
		const output = [];
		const safeAnswers = asArray(answers);

		for (let i = 0; i < safeAnswers.length; i++) {
			const answerArray = asString(safeAnswers[i]).split(' ');
			output.push(
				answerArray.map((answer, index) => {
					return {
						id: index,
						value: answer,
					};
				})
			);
		}
		return output;
	}

	getAnswersWithCorrectAnswer(answers, answersCorrect, questions) {
		const output = [];
		const safeAnswers = asArray(answers);
		const safeAnswersCorrect = asArray(answersCorrect);
		const safeQuestions = asArray(questions);

		for (let i = 0; i < safeAnswers.length; i++) {
			let jInit = 0;
			let correctAnswerAltValues = null;

			if (
				safeAnswers[i] &&
				safeAnswersCorrect[i] &&
				safeAnswers[i].id === safeAnswersCorrect[i].id
			) {
				jInit = i;
			}

			if (!safeAnswers[i] || typeof safeAnswers[i].id === 'undefined') {
				break;
			}

			const currentAnswer = safeAnswers[i];
			const currentAnswerValue = asString(currentAnswer.value)
				.toLowerCase()
				.trim();

			for (let j = jInit; j < safeAnswersCorrect.length; j++) {
				const currentCorrectAnswer = safeAnswersCorrect[j];

				if (!currentCorrectAnswer) {
					continue;
				}

				if (currentAnswer.id === currentCorrectAnswer.id) {
					const correctAnswerValue = asString(
						currentCorrectAnswer.value
					)
						.toLowerCase()
						.trim();

					if (
						safeAnswersCorrect[j] &&
						Object.prototype.hasOwnProperty.call(
							safeAnswersCorrect[j],
							'altValues'
						)
					) {
						correctAnswerAltValues =
							safeAnswersCorrect[j].altValues;
					}

					const isCorrectAnswer =
						currentAnswerValue === correctAnswerValue ||
						currentAnswerValue === correctAnswerAltValues;

					const hasAltValues =
						Array.isArray(currentCorrectAnswer.altValues) ||
						correctAnswerAltValues;

					const isCorrectAltValue =
						Array.isArray(currentCorrectAnswer.altValues) &&
						currentCorrectAnswer.altValues.indexOf(
							currentAnswerValue
						) !== -1;

					const answer = {
						id: currentAnswer.id,
						value: currentAnswerValue,
						isCorrect: isCorrectAnswer || isCorrectAltValue,
						correctValues: [correctAnswerValue],
					};

					if (hasAltValues) {
						answer.correctValues = [correctAnswerValue].concat(
							Array.isArray(currentCorrectAnswer.altValues)
								? currentCorrectAnswer.altValues
								: []
						);
					}

					if (questions) {
						const question = safeQuestions[currentAnswer.id - 1];
						answer.question = question ? question.question : '';
						answer.choices = getSafeQuestionChoices(question);
					}

					output.push(answer);
					break;
				}
			}
		}
		return output;
	}

	getAnswersWithCorrectAnswerforWD(
		answers,
		answersCorrect,
		questions,
		childGrade
	) {
		const output = [];
		const safeAnswers = asArray(answers);
		const safeAnswersCorrect = asArray(answersCorrect);
		const safeQuestions = asArray(questions);
		const childGradeNumber = Number(childGrade);
		const useLowerGrade = childGradeNumber < 4;
		const punctuation = /[\.,?!]/g;

		for (let i = 0; i < safeAnswers.length; i++) {
			let jInit = 0;

			if (
				safeAnswers[i] &&
				safeAnswersCorrect[i] &&
				safeAnswers[i].id === safeAnswersCorrect[i].id
			) {
				jInit = i;
			}

			if (!safeAnswers[i] || typeof safeAnswers[i].id === 'undefined') {
				break;
			}

			const currentAnswer = safeAnswers[i];
			const currentAnswerValue = asString(currentAnswer.value)
				.toLowerCase()
				.trim()
				.replace(punctuation, '');

			for (let j = jInit; j < safeAnswersCorrect.length; j++) {
				const currentCorrectAnswer = safeAnswersCorrect[j];

				if (!currentCorrectAnswer) {
					continue;
				}

				if (currentAnswer.id === currentCorrectAnswer.id) {
					const correctAnswerSource = useLowerGrade
						? currentCorrectAnswer.value
						: currentCorrectAnswer.upperGradeValue;

					const correctAnswerValue = asString(correctAnswerSource)
						.toLowerCase()
						.trim();

					const isCorrectAnswer =
						currentAnswerValue === correctAnswerValue;

					const hasAltValues = Array.isArray(
						currentCorrectAnswer.altValues
					);

					const answer = {
						id: currentAnswer.id,
						value: currentAnswerValue,
						isCorrect: isCorrectAnswer,
						correctValues: [correctAnswerValue],
					};

					if (hasAltValues) {
						answer.correctValues = [correctAnswerValue].concat(
							currentCorrectAnswer.altValues
						);
					}

					if (questions) {
						const question = safeQuestions[currentAnswer.id - 1];
						answer.question = question ? question.question : '';
						answer.choices = getSafeQuestionChoices(question);
					}

					output.push(answer);
					break;
				}
			}
		}
		return output;
	}

	getAnswersWithCorrectAnswerforWC(
		createdAt,
		answers,
		answerCorrectBackEnd,
		answersCorrect,
		answerCorrectNn,
		questions,
		subtestLanauge
	) {
		const createdMoment = moment(createdAt);
		const correctAnswerFile =
			subtestLanauge === 'no' ? answersCorrect : answerCorrectNn;
		const output = [];
		const safeAnswers = asArray(answers);
		const safeAnswerCorrectBackEnd = asArray(answerCorrectBackEnd);
		const safeCorrectAnswerFile = asArray(correctAnswerFile);
		const safeQuestions = asArray(questions);

		const answersToCompare =
			createdMoment.isValid() &&
			createdMoment.isBefore(timeSinceWCaltered)
				? safeCorrectAnswerFile
				: safeAnswerCorrectBackEnd;

		for (let i = 0; i < safeAnswers.length; i++) {
			let jInit = 0;

			if (
				safeAnswers[i] &&
				answersToCompare[i] &&
				safeAnswers[i].id === answersToCompare[i].id
			) {
				jInit = i;
			}

			if (!safeAnswers[i] || typeof safeAnswers[i].id === 'undefined') {
				break;
			}

			const currentAnswer = safeAnswers[i];
			const currentAnswerValue = asString(currentAnswer.value)
				.toLowerCase()
				.trim();

			for (let j = jInit; j < answersToCompare.length; j++) {
				const currentCorrectAnswer = answersToCompare[j];

				if (!currentCorrectAnswer) {
					continue;
				}

				if (currentAnswer.id === currentCorrectAnswer.id) {
					const correctAnswerValue = asString(
						currentCorrectAnswer.value
					)
						.toLowerCase()
						.trim();

					const isCorrectAnswer =
						currentAnswerValue === correctAnswerValue;

					const hasAltValues = Array.isArray(
						currentCorrectAnswer.altValues
					);

					const isCorrectAltValue =
						hasAltValues &&
						currentCorrectAnswer.altValues.indexOf(
							currentAnswerValue
						) !== -1;

					const answer = {
						id: currentAnswer.id,
						value: currentAnswerValue,
						isCorrect: isCorrectAnswer || isCorrectAltValue,
						correctValues: [correctAnswerValue],
					};

					if (hasAltValues) {
						answer.correctValues = [correctAnswerValue].concat(
							currentCorrectAnswer.altValues
						);
					}

					if (questions) {
						const question = safeQuestions[currentAnswer.id - 1];
						answer.question = question ? question.question : '';
						answer.choices = getSafeQuestionChoices(question);
					}

					output.push(answer);
					break;
				}
			}
		}

		return output;
	}

	returnTestUserGrade() {
		let testUserGrade = null;
		const testUser = this.state.testUser || {};
		const education = get(testUser, 'education', {});

		if (
			['child-screening', 'youth-screening'].includes(this.state.testType)
		) {
			const youthGrade = get(education, 'youthGrade');

			testUserGrade = (
				<>
					<br />
					{hasValue(youthGrade)
						? `${youthGrade}.${strings.grade}`
						: `${strings.grade}: ${NOT_AVAILABLE}`}
					<br />
				</>
			);
		} else if (
			education &&
			Object.prototype.hasOwnProperty.call(
				education,
				'highestCompletedEducation'
			)
		) {
			const highestCompletedEducation = get(
				education,
				'highestCompletedEducation',
				strings.notavailable || NOT_AVAILABLE
			);

			testUserGrade = (
				<>
					<br />
					{`${strings.education}: ${highestCompletedEducation}`}
					<br />
				</>
			);
		}
		return testUserGrade;
	}

	setRelevantTab(key, index) {
		const {buttonTabs} = this.state;
		for (let i = 0; i < buttonTabs.length; i++) {
			if (
				i === index &&
				!buttonTabs[index].buttonClass.includes('active')
			) {
				const counter = index + 1;
				buttonTabs[index].buttonClass = `tablink${counter}-active`;
			} else {
				const counter = i + 1;
				buttonTabs[i].buttonClass = `tablink${counter}`;
			}
		}
		switch (key) {
			case 'result':
				this.setState({
					showResultsTab: true,
					showReportTab: false,
					showInformationTab: false,
					showTestUserInfo: false,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'report':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: true,
					showTestUserInfo: false,
					showHandBookTab: false,

					showHandBookActive: 'tablink4',
					buttonTabs,
				});
				break;
			case 'info':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: false,
					showTestUserInfo: true,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'book':
				this.setState({
					showResultsTab: false,
					showReportTab: false,
					showInformationTab: false,
					showHandBookTab: true,
					showTestUserInfo: false,
					buttonTabs,
				});
				break;
		}
	}
	toggleAddNotesModal = () => {
		this.setState({showAddNotesModal: !this.state.showAddNotesModal});
	};
	render() {
		const {showTestUserInfo, testResult, birthDate, reportNotes} =
			this.state;
		if (!testResult) {
			return null;
		}

		const testUser = testResult.testUser || {};
		const safeSubtests = asArray(testResult.subtests);
		const {
			currentUser: {
				firstName: adminFirstName = '',
				lastName: adminLastName = '',
			} = {},
		} = this.props;

		const adminCompleteName = `${adminFirstName} ${adminLastName}`.trim();
		const ownerFullName = testResult.adminFullName
			? testResult.adminFullName
			: '<Ikke tilgjengelig>';
		const isCommon = adminCompleteName === ownerFullName;
		const completeName = getCompleteName(testUser);
		const firstName = get(testUser, 'firstName', '<Skjult namn>');
		const youthGrade = get(testUser, 'education.youthGrade');

		return (
			<div className="lit-single-test">
				<div>
					<div
						className={
							this.state.testType === 'youth-screening'
								? 'lit-single-youthtest-title-desc'
								: 'lit-single-adulttest-title-desc'
						}
					>
						<h1 className="lit-page-title">
							{this.state.showHandBookTab
								? strings.formatString(
										strings.handbooktitle,
										<>
											<b>Handbok</b>
											<br />
											<br />
										</>
									)
								: this.state.showResultsTab
									? strings.formatString(
											strings.dynamicheaderfortestresult_adult,
											this.state.testType ===
												'youth-screening' ? (
												<>
													<br />
													<br />
													<b>
														{strings.youthscreening}
													</b>
												</>
											) : this.state.testType ===
											  'adult-screening' ? (
												<>
													<br />
													<br />
													<b>
														{strings.adultscreening}
													</b>
												</>
											) : (
												<b>
													<br />
													<br />
													{
														'Dysmate - C (Screeningtest for barn)'
													}
												</b>
											)
										)
									: this.state.showTestUserInfo
										? strings.formatString(
												strings.dynamicheaderfortestcandidate_adult,
												this.state.testType ===
													'youth-screening' ? (
													<>
														<br />
														<br />
														<b>
															{
																strings.youthscreening
															}
														</b>
													</>
												) : this.state.testType ===
												  'adult-screening' ? (
													<>
														<br />
														<br />
														<b>
															{
																strings.adultscreening
															}
														</b>
													</>
												) : (
													<>
														<b>
															<br />
															<br />
															{
																'Dysmate - C (Screeningtest for barn)'
															}
														</b>
													</>
												)
											)
										: this.state.showReportTab
											? strings.formatString(
													strings.dynamicheaderfortestreport_adult,
													this.state.testType ===
														'youth-screening' ? (
														<>
															<br />
															<br />
															<b>
																{
																	strings.youthscreening
																}
															</b>
														</>
													) : this.state.testType ===
													  'adult-screening' ? (
														<>
															{' '}
															<br />
															<br />
															<b>
																{
																	strings.adultscreening
																}
															</b>
														</>
													) : (
														<>
															<br /> <br />
															<b>
																{
																	'Dysmate - C (Screeningtest for barn)'
																}
															</b>
														</>
													)
												)
											: ''}
						</h1>
						<div>
							{!this.state.showHandBookTab &&
								this.state.showReportTab &&
								!this.state.showTestUserInfo && (
									<>
										<br />
										<span className="lit-printed-by">
											{'Administratör: '}
										</span>
										<b style={{marginLeft: '4px'}}>
											{ownerFullName}
										</b>
										{!isCommon && (
											<>
												<span className="lit-printed-by">
													{'Lagret av: '}
												</span>
												<b style={{marginLeft: '4px'}}>
													{adminCompleteName}
												</b>
											</>
										)}
									</>
								)}
						</div>
						{!this.state.showHandBookTab && (
							<p className="lit-page-lead">
								{strings.formatString(
									this.state.showResultsTab
										? strings.info_results_belowpresentsinformation
										: this.state.showTestUserInfo
											? strings.info_user_belowpresentsinformation
											: this.state.showReportTab
												? strings.info_report_belowpresentsinformation
												: '',
									<>
										<br />
										<br />
										<b>{completeName}</b>
										<br />{' '}
									</>,

									<span>{birthDate}</span>,
									<span>{this.returnTestUserGrade()}</span>
								)}
								{testResult.completedAt ? (
									strings.formatString(
										strings.info_testwascompletedon,
										<>
											<b>
												{moment(
													testResult.completedAt
												).format('DD.MM.YYYY')}
												.
											</b>
											<br />
										</>
									)
								) : (
									<>
										{strings.info_testwasNotcompletedon}{' '}
										<br />
									</>
								)}
								{/* TODO:: DO something about missing age for testgs created with a csv file */}
								{/* {strings.formatString(
									strings.infor_scr_ageAtCommencement,
									<b>{testUser.age.years || '--'}</b>,

									<b>{testUser.age.months || '--'}</b>
								)} */}
							</p>
						)}
					</div>

					<div className="lit-tab-wrapper">
						<div className="lit-results-line" />
						{this.state.buttonTabs.map((tab, index) => {
							const id = tab.id;
							const value = tab.value;
							const buttonClass = tab.buttonClass;
							const btnText = tab.text;

							// eslint-disable-next-line react/jsx-key
							return (
								<button
									className={buttonClass}
									id={id}
									key={index}
									value={value}
									disabled={buttonClass.includes('active')}
									onClick={(e) => {
										this.setRelevantTab(
											e.target.value,
											index
										);
									}}
								>
									{btnText}
								</button>
							);
						})}
					</div>
					{this.state.showHandBookTab &&
						!this.state.showResultsTab &&
						!this.state.showReportTab &&
						!this.state.showInformationTab}
					{this.state.showResultsTab &&
						!this.state.showHandBookTab &&
						!this.state.showReportTab &&
						!this.state.showInformationTab && (
							<div className="lit-histogram-Test_Details">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											window.print();
											this.updatePrintLog('Results');
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.testresult
											)}
										</p>
									</button>
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.incompleteMessage}
											</div>
										)}

										<h3 className="sub-test__name big">
											{strings.formatString(
												strings.summary,
												strings.testresult
											)}
										</h3>
										<div className="summary-chart">
											<HorizontalBarChart
												subtests={safeSubtests}
												testType={this.state.testType}
											/>
										</div>
										<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														strings.zscorered,
														<em>{strings.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{strings.zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														strings.zscoregreen,
														<em>{strings.over}</em>
													)}
												</p>
											</div>
										</div>
									</div>

									<div className="print-sub-tests">
										{safeSubtests.map((subtest) => {
											return (
												<Subtest
													subtest={subtest}
													type={this.state.testType}
													testType={
														this.state.testType
													} //is going to be used for better rendering of gjennomsnitting og stadaravvik skåre
													testResult={
														this.state.testResult
													}
													key={subtest.id}
												>
													<SubtestAnswers
														subtest={subtest}
														grade={youthGrade}
														testType={
															this.state.testType
														}
														viewModes={
															this.state
																.viewModes || {}
														}
													/>
												</Subtest>
											);
										})}
									</div>
								</div>
							</div>
						)}

					{showTestUserInfo && (
						<TestUserInfo
							testResult={testResult}
							testType={this.state.testType}
						/>
					)}
					{this.state.showReportTab &&
						!this.state.showHandBookTab &&
						!this.state.showTestUserInfo && (
							<div className="lit-histogram-Test_Report">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											this.updatePrintLog('Report');
											this.setState({reportNotes: ''});
											this.toggleAddNotesModal();
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.testreport
											)}
										</p>
									</button>
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.incompleteMessage}
											</div>
										)}

										<h3 className="sub-test__name big">
											{strings.formatString(
												strings.summary,
												strings.testreport
											)}
										</h3>

										<div className="summary-chart">
											<HorizontalBarChart
												subtests={testResult.subtests}
												testType={this.state.testType}
											/>
										</div>
										<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														strings.zscorered,
														<em>{strings.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{strings.zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														strings.zscoregreen,
														<em>{strings.over}</em>
													)}
												</p>
											</div>
										</div>

										<div className="print-sub-tests">
											<h2
												className="sub-test-Report__name"
												style={{color: '#0f4256'}}
											>{`Screeningens deltest`}</h2>
											{safeSubtests.map(
												(subtest, index) => {
													return (
														<SubtestReport
															subtest={subtest}
															key={subtest.id}
															order={index + 1}
															type={
																this.state
																	.testType
															}
															testResult={
																this.state
																	.testResult
															}
														/>
													);
												}
											)}
										</div>
										<div className="lit-report-assessment">
											<Assessment
												testResult={testResult}
												completeName={completeName}
												firstName={firstName}
											/>
										</div>

										{reportNotes && (
											<>
												<div className="sub-test__comment-page-breaker" />
												<div className="sub-test__comment">
													<h4 className="sub-test__heading big">
														<span className="comment">
															Kommentarer:
														</span>
														<p className="report-notes">
															{reportNotes}
														</p>
														<div className="line-one-text">
															Kommentaren är
															skriven av
															testadministratör:{' '}
															{ownerFullName}
														</div>
														<div className="line-container">
															<div className="line line-1" />
														</div>
													</h4>
												</div>
											</>
										)}
									</div>
								</div>
							</div>
						)}

					{this.state.showHandBookTab && <HandBook />}
					{this.state.showAddNotesModal && (
						<AddNotesModal
							showModal={this.state.showAddNotesModal}
							toggleModal={this.toggleAddNotesModal}
							reportNotes={reportNotes}
							setReportNotes={(notes) => {
								this.setState({reportNotes: notes});
							}}
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SingleTest)
);
